/**
 * 转换金额
 * eg: 1000million USD / 100000万美元
 */
export function formatMoney(value, lng) {
  let { currency } = value;
  const { money } = value;
  currency = (currency || '').toUpperCase();

  if (lng === 'en') {
    // 1000million USD
    return `${money / 1000000} million ${currency}`;
  }

  const map = {
    USD: '美元',
    CNY: '人民币',
  };

  // 2000万人民币
  return `${money / 10000}万${map[currency] || currency}`;
}

/**
 * 返回序号
 * @param {*} value
 * @param {*} lng
 */
export function formatOrdinalNumber(value, lng) {
  if (lng === 'en') {
    const j = value % 10;
    const k = value % 100;
    if (j === 1 && k !== 11) {
      return `${value}st`;
    }
    if (j === 2 && k !== 12) {
      return `${value}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${value}rd`;
    }
    return `${value}th`;
  }

  return `第${value}`;
}

/**
 * 组合用户类型为 "财务（xxx）/法务（xxx）/"的格式
 * @param {Array|Object} useValue 需为UserModel
 * @param {*} lng
 */
export function formatUserType(useValue, lng) {
  let value = Array.isArray(useValue) ? useValue : [useValue];
  // 采用duck check形式，不引入model
  if (lng === 'en') {
    value = value.map((v) => {
      let position;
      if (v?.isDL()) {
        position = 'DL';
      } else if (v?.isOperator()) {
        position = 'Operation';
      } else if (v?.isLeader()) {
        position = 'Director';
      } else if (v?.isFinance()) {
        position = 'Finance Owner';
      } else if (v?.isLegal()) {
        position = 'Legal Owner';
      } else if (v?.isTax()) {
        position = 'Tax Owner';
      } else if (v?.isQuality()) {
        position = 'QC';
      }

      return position ? `${position}（${v.user_name_en}）` : v.user_name_en;
    });
  } else {
    value = value.map((v) => {
      let position;
      if (v?.isDL()) {
        position = 'DL';
      } else if (v?.isOperator()) {
        position = '运营';
      } else if (v?.isLeader()) {
        position = '中干';
      } else if (v?.isFinance()) {
        position = '财务';
      } else if (v?.isLegal()) {
        position = '法务';
      } else if (v?.isTax()) {
        position = '税务';
      } else if (v?.isQuality()) {
        position = '质量管控';
      }

      return position ? `${position}（${v.user_name_en}）` : v.user_name_en;
    });
  }

  return value.join('/ ');
}
